module.exports = __webpack_public_path__ + "img/logo-ja-blue-black.3dc60cd4.svg";